import { useCallback, useEffect, useRef, useState } from 'react';
import { validateFormAiDocument } from '../utils/formAiDocument';

export default function useFormAiDocument() {
  const [file, setFile] = useState(null);
  const operation = useRef(null);
  const cancel = useCallback(() => {
    operation.current?.controller.abort();
    operation.current = null;
  }, []);
  useEffect(() => cancel, [cancel]);
  const choose = (nextFile) => {
    cancel();
    const error = validateFormAiDocument(nextFile);
    setFile(error ? null : nextFile);
    return error;
  };
  const reset = () => { cancel(); setFile(null); };
  const start = () => {
    cancel();
    const controller = new AbortController();
    const token = { controller, signal: controller.signal };
    operation.current = token;
    return token;
  };
  const isCurrent = (token) => operation.current === token && !token.signal.aborted;
  return { file, choose, reset, cancel, start, isCurrent };
}
